import React from 'react';
import config from '../config';

const RHCAElectronic = () => {
  return (
    <>
      <section className="page-header">
        <div className="page-header-bg" style={{ backgroundImage: "url(assets/images/backgrounds/buildin.jpg)" }}>
        </div>
        <div className="container">
          <div className="page-header__inner">
            <h2>RHCA - Electronic City</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li>RHCA - Electronic City</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Blog Details Start */}
      <section className="blog-details">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-7">
              <div className="blog-details__left">
                <div className="blog-details__img">
                  <img src="assets/images/backgrounds/main.jpg" alt="" />

                </div>
                <div className="blog-details__content">

                  <h3 className="blog-details__title">We Are Now Open in Electronic City!</h3>
                  <p className="blog-details__text-1">
                    We are delighted to welcome families to our Electronic City Centre, which has now been serving the community for the past six months.
                  </p>
                  <p className="blog-details__text-2">
                    For over 10 years, our Hosur centre has been committed to providing evidence-informed, compassionate, and family-centred services. We are proud to bring the same values, expertise, and quality of care to our Electronic City centre.
                  </p>
                  <p className="blog-details__text-2">
                    Our multidisciplinary team offers services in:
                  </p>
                  <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '10px 0 0 10px' }}>
                    <li>Applied Behavior Analysis (ABA)</li>
                    <li>Speech-Language Pathology</li>
                    <li>Occupational Therapy</li>
                    <li>Special Education</li>
                  </ul>
                  <p className="blog-details__text-2">
                    Every child is unique, and we believe that meaningful progress begins with understanding, collaboration, and trust. Whether you are seeking an evaluation, intervention, or guidance, our team is here to partner with your family every step of the way.
                  </p>
                  <p className="blog-details__text-2">
                    We invite you to visit our Electronic City centre, meet our team, and learn more about our approach. We look forward to supporting your child and walking alongside your family on this journey.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-details">
        <div className="container">
          <div className="contact-details__inner">
            <div className="contact-details__inner-content">
              <div className="contact-details__shape-1 float-bob-y">
                <img src={`${config.baseUrl}/assets/images/shapes/contact-details-shape-1.png`} alt="" />
              </div>
              <ul className="list-unstyled contact-details__list">
                <li>
                  <div className="icon">
                    <span className="icon-help"></span>
                  </div>
                  <div className="content">
                    <p>Have Question?</p>
                    <h4><a href="tel:7305988924">7305988924</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-mailbox"></span>
                  </div>
                  <div className="content">
                    <p>Write Email</p>
                    <h4><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-maps-and-flags"></span>
                  </div>
                  <div className="content">
                    <p>Visit Center</p>
                    <h4>RR Towers, 134/106/43, Hosur Main Road, Hosa Road Intersection, Opposite Hosa Road Metro station, <br />Chikkathoguru, Bengaluru, Karnataka – 560100</h4>
                  </div>
                </li>
                <li>
                  {/* <div className="icon">
                    <span className="fas fa-clock"></span>
                  </div>
                  <div className="content">
                    <p>Operating Hours</p>
                    <h4>
                      Monday – Friday: 9:00 AM – 6:00 PM<br/>
                      1st, 3rd, 5th Saturdays: 9:00 AM – 3:00 PM<br/>
                      2nd & 4th Saturdays, Sundays: Closed
                    </h4>
                  </div> */}
                </li>
                <li>
                  <div className="contact-details__social">
                    <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank' rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                    <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank' rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                    <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank' rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                    <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank' rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="google-map-two">
        <iframe
          title="Google Maps Location"
          src="https://maps.google.com/maps?q=Ray%20of%20Hope%20Center%20for%20Autism,%20RR%20Towers,%20134/106/43,%20Hosur%20Main%20Road,%20Hosa%20Road%20Intersection,%20Opposite%20Hosa%20Road%20Metro%20station,%20Chikkathoguru,%20Bengaluru,%20Karnataka%20-%20560100&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="google-map__two"
          allowFullScreen
        ></iframe>
      </section>
    </>
  );
};

export default RHCAElectronic;